import vue from 'vue'
/* eslint-disable */ 
vue.prototype.$clipboard = function(text : string ){
  const element = document.createElement('textarea');
  element.value = text;
  document.body.appendChild(element);
  element.select();
  document.execCommand('copy')
}